// MAIN COLORS - VUESAX THEME COLORS
const colors = {
  primary: '#3D3D3D',
  success: '#538a1b',
  danger: '#dd473b',
  warning: '#fcb73e',
  dark: '#1E1E1E'
}

import Vue from 'vue'
import Vuesax from 'vuesax'
Vue.use(Vuesax, { theme: { colors }})

export default colors
